import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../styles/SummaryPage.css";
import CommonTable from "../../Components/CommonTable";
import { 
    donainComplianceReportService, 
    overallComplianceReportService, 
    ownerBaseComplianceReportService 
} from "../../services";

export default function SummaryPage() {
    const { frameworkId, frameworkName } = useParams();
    const organization_id = sessionStorage.getItem("organization_id");
    const navigate = useNavigate();

    const [controlsTable, setControlsTable] = useState([]);
    const [complianceByDomainTable, setComplianceByDomainTable] = useState([]);
    const [complianceByOwnerTable, setComplianceByOwnerTable] = useState([]);
    const [loading, setLoading] = useState(false);

    // GENERIC FETCH HELPER
    const fetchComplianceData = async (serviceFn, setStateFn, dataType) => {
        try {
            setLoading(true);

            const query = `?organization_id=${organization_id}&framework_id=${frameworkId}`;
            const res = await serviceFn(query);
            console.log(res, 'asdfgfdrsedawsqawertfdr')

            if (res?.statusCode?.status) {
                if(dataType == 1){
                    setStateFn(res?.statusCode?.response_data?.data?.domains || []);
                }

                if(dataType == 2){
                    setStateFn(res?.statusCode?.response_data?.data || {});
                }

                if(dataType == 3){
                    setStateFn(res?.statusCode?.response_data?.data?.users || {});
                }
                
            }

        } catch (error) {
            console.error("Error fetching compliance report:", error);
        } finally {
            setLoading(false);
        }
    };

    // API CALLS
    useEffect(() => {
        if (frameworkId) {
            fetchComplianceData(donainComplianceReportService, setControlsTable, 1);
            fetchComplianceData(overallComplianceReportService, setComplianceByDomainTable, 2);
            fetchComplianceData(ownerBaseComplianceReportService, setComplianceByOwnerTable, 3);
        }
    }, [frameworkId]);

    const getColor = (p) => {
        if (p === 100) return "#0f0";
        if (p >= 70) return "#ffd27f";
        if (p >= 40) return "#ff9d57";
        if (p > 0) return "#ff6633";
        return "#ff2e2e";
    };

    // COMPLIANCE BY DOMAIN (Dynamic)
    const complianceByDomainHeader = [
        "Domain",
        "Total",
        "Compliant",
        "Partial",
        "Non-Compliant",
        "Percentage",
    ];

    const complianceByDomainRows = controlsTable.map((row) => {
        const percentage = row.percentage;

        return {
            data: [
                row.domain_name,
                row.total_controls,
                row.compliant,
                row.partial_compliant,
                row.non_compliant,
                <td style={{ color: getColor(percentage), fontWeight: "600", textAlign: "center" }}>
                    {percentage}%
                </td>,
            ],
        };
    });


        // COMPLIANCE BY DOMAIN (Dynamic)
        const complianceByOwnerHeader = [
            "Owner",
            "Total",
            "Compliant",
            "Partial Compliant",
            "Non-Compliant",
            "Percentage",
        ];
    
        const complianceByOwnerRows = complianceByOwnerTable.map((row) => {
            const percentage = row.percentage;
    
            return {
                data: [
                    row.user_email,
                    row.total_questions,
                    row.compliant,
                    row.partial,
                    row.non_compliant,
                    <td style={{ color: getColor(percentage), fontWeight: "600", textAlign: "center" }}>
                        {percentage}%
                    </td>,
                ],
            };
        });


  

    return (
        <div className="summary-container">
            {console.log(complianceByOwnerTable, 'complianceByOwnerTablecomplianceByOwnerTablecomplianceByOwnerTable')}
            <div className="summary-header">
                <h2>Report - {frameworkName.replace(/-/g, " ")}</h2>
            </div>

            {loading && <p style={{ textAlign: "center" }}>Loading...</p>}

            <div className="summary-grid">

                {/* LEFT SIDE */}
                <div className="left-section dark_bg_color">
                    <div className="summary_report_box">
                        <h3 className="font_24 mt-2">Controls</h3>

                        <div className="control_total_box">
                            <div className="d-flex justify-content-between align-items-center"><p><b>Total Controls</b></p><span className="cm_line_bar"></span><p>{complianceByDomainTable?.total_controls || 0}</p></div>
                            <div className="d-flex justify-content-between align-items-center"><p><b>Compliant</b></p><span className="cm_line_bar"></span><p>{complianceByDomainTable?.compliant}</p></div>
                            <div className="d-flex justify-content-between align-items-center"><p><b>Partially Compliant</b></p><span className="cm_line_bar"></span><p>{complianceByDomainTable?.partially_compliant}</p></div>
                            <div className="d-flex justify-content-between align-items-center"><p><b>Non Compliant/Open</b></p><span className="cm_line_bar"></span><p>{complianceByDomainTable?.non_compliant}</p></div>
                            <div className="d-flex justify-content-between align-items-center"><p><b>Evidence Adequate</b></p><span className="cm_line_bar"></span><p>{complianceByDomainTable?.evidence_adequate}</p></div>
                            <div className="d-flex justify-content-between align-items-center"><p><b>OverallReadiness</b></p><span className="cm_line_bar"></span><p>{complianceByDomainTable?.overall_readiness}</p></div>
                        </div>

                        <h3 className="font_24 mt-4">Compliance by Domain</h3>
                        <CommonTable noPadding={true} headers={complianceByDomainHeader} rows={complianceByDomainRows} />

                        <h3 className="font_24 mt-4">Compliance by Owner</h3>
                        <CommonTable noPadding={true} headers={complianceByOwnerHeader} rows={complianceByOwnerRows} />
                    </div>
                </div>

                {/* RIGHT SIDE STATIC INFO */}
                <div className="right-section dark_bg_color">
                    <div className="gaps-box">
                        <h3>Gaps</h3>
                        <ul className="px-3 mb-1">
                            <li>Authentication issues</li>
                            <li>Data Retention Gaps</li>
                            <li>Unmapped Policies</li>
                        </ul>
                    </div>

                    <div className="help-box">
                        <h3>How can we help?</h3>
                        <ul className="px-3 mb-1">
                            <li>Implementation support</li>
                            <li>Policy creation</li>
                            <li>Evidence collection</li>
                        </ul>
                    </div>

                    <div className="cert-box" style={{ cursor: "pointer" }}>
                        <h3>Sample Certificate</h3>
                        <div className="cert-preview">
                            <p>Click to Preview</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
